import { icons } from "constants/icons";
import React, { memo } from "react";
import {
  formatTimeFromUtc,
  round,
  jointIdList,
} from "../../../../utils/formatters";
import { ScoreDelta } from "components/ScoreDelta/ScoreDelta";

type Props = {
  jointId: string;
  side?: string;
  type: string;
  leftKneeSD?: {
    value?: number | null;
    isBetter?: boolean;
  };
  rightKneeSD?: {
    value?: number | null;
    isBetter?: boolean;
  };
  bothKneeSD?: [
    {
      leftValue?: number | null;
      leftIsBetter?: boolean;
    },
    {
      rightValue?: number | null;
      rightIsBetter?: boolean;
    }
  ];
  isFreeForm?: boolean;
  createdDate: string;
};

export const VideoExamTableRow = memo(
  ({
    jointId,
    leftKneeSD,
    rightKneeSD,
    bothKneeSD,
    createdDate,
    isFreeForm,
  }: Props) => {
    return (
      <div className="flex w-full bg-bgLight border border-border rounded-lg p-3 text-grayDark">
        <div className="flex space-x-4 items-center" style={{ width: 250 }}>
          <img src={icons.status} alt="status" />
          <p>
            <strong className="capitalize font-normal">
              {isFreeForm ? "Free form exam" : jointIdList[jointId]}
            </strong>
          </p>
          <p />
        </div>
        {!isFreeForm && (
          <>
            <div className="text-center" style={{ width: 100 }}>
              {
                <div className="flex space-x-1 items-baseline">
                  <p title="Left Minimum Value">
                    {leftKneeSD?.value?.toFixed(2) ?? "-"}
                  </p>
                  {leftKneeSD?.value && (
                    <ScoreDelta isBetter={leftKneeSD?.isBetter} />
                  )}
                </div>
              }
            </div>
            <div className="text-center" style={{ width: 100 }}>
              {
                <div className="flex space-x-1 items-baseline">
                  <p title="Right Minimum Value">
                    {rightKneeSD?.value?.toFixed(2) ?? "-"}
                  </p>
                  {rightKneeSD?.value && (
                    <ScoreDelta isBetter={rightKneeSD?.isBetter} />
                  )}
                </div>
              }
            </div>
            <div className="text-center" style={{ width: 200 }}>
              {
                <div className="flex space-x-1 items-baseline">
                  {bothKneeSD?.[0].leftValue || bothKneeSD?.[1].rightValue ? (
                    <>
                      <p title="Left Minimum Value">
                        {bothKneeSD?.[0].leftValue?.toFixed(2)}
                      </p>
                      {bothKneeSD?.[0].leftValue && (
                        <ScoreDelta isBetter={bothKneeSD?.[0].leftIsBetter} />
                      )}
                      <p title="Right Minimum Value">
                        {bothKneeSD?.[1].rightValue?.toFixed(2)}
                      </p>
                      {bothKneeSD?.[1].rightValue && (
                        <ScoreDelta isBetter={bothKneeSD?.[1].rightIsBetter} />
                      )}
                    </>
                  ) : (
                    <p>-</p>
                  )}
                </div>
              }
            </div>
          </>
        )}

        <div className="text-center" style={{ width: 100 }}>
          <p>{formatTimeFromUtc(createdDate)}</p>
        </div>
      </div>
    );
  }
);
